import { render } from "./ForgotPassword.vue?vue&type=template&id=71f6fa76"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "./ForgotPassword.vue?vue&type=style&index=0&id=71f6fa76&lang=css"

import exportComponent from "/builds/websites/koch-bus-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__